/**
 * Allows to TypeScript recognize Facebook namespace
 */
declare global {
    interface Window {
        fbq: any;
        facebookProductPagesViewContent: any;
        fbAsyncInit: Function;
    }
}

export {}

export enum EFacebookStatus {
    Error = -1,
    LoggedIn = 0,
}

export interface IFacebookResponse {
    status: EFacebookStatus,
    accessToken: string,
    userID: string,
}

export interface IFacebookUser {
    name: string;
    email: string;
}
